export enum ELayoutPosition {
  invisible = 0,
  primary = 1,
  secondary = 2
}
